import {useEffect, useState} from "react";

import {isEmpty} from "@pg-mono/nodash";

import {CalculatorValueType} from "../types/CalculatorValueType";
import {ICalculatorOptions} from "../types/ICalculatorOptions";
import {getCreditFiltersStorage} from "../utils/credit_storage";
import {setFiltersStateInitialValue} from "../utils/set_filters_state_initial_value";

export const useFiltersState = (initialValues: ICalculatorOptions[]) => {
    const [price, setPrice] = useState<number>(() => setFiltersStateInitialValue(CalculatorValueType.PRICE, initialValues));
    const [contribution, setContribution] = useState<number>(() => setFiltersStateInitialValue(CalculatorValueType.CONTRIBUTION, initialValues));
    const [period, setPeriod] = useState<number>(() => setFiltersStateInitialValue(CalculatorValueType.PERIOD, initialValues));
    const [areDefaultValuesSet, setAreDefaultValuesSet] = useState<boolean>(false);

    useEffect(() => {
        const filtersStorage = getCreditFiltersStorage();

        if (!isEmpty(filtersStorage)) {
            updateAllValues(filtersStorage.price, filtersStorage.contribution, filtersStorage.period);
        }

        setAreDefaultValuesSet(true);
    }, []);

    const updateValue = (type: CalculatorValueType, value: number) => {
        switch (type) {
            case CalculatorValueType.PRICE:
                setPrice(value);
                break;
            case CalculatorValueType.CONTRIBUTION:
                setContribution(value);
                break;
            case CalculatorValueType.PERIOD:
                setPeriod(value);
                break;
            default:
                console.error("modifyValue - type error");
        }
    };
    const updateAllValues = (price: number, contribution: number, period: number) => {
        setPrice(price);
        setContribution(contribution);
        setPeriod(period);
    };

    return {price, contribution, period, areDefaultValuesSet, updateValue};
};
import {useEffect, useState} from "react";

import {isEmpty} from "@pg-mono/nodash";

import {CalculatorValueType} from "../types/CalculatorValueType";
import {ICalculatorOptions} from "../types/ICalculatorOptions";
import {getCreditFiltersStorage} from "../utils/credit_storage";
import {setFiltersStateInitialValue} from "../utils/set_filters_state_initial_value";

export const useFiltersState = (initialValues: ICalculatorOptions[]) => {
    const [price, setPrice] = useState<number>(() => setFiltersStateInitialValue(CalculatorValueType.PRICE, initialValues));
    const [contribution, setContribution] = useState<number>(() => setFiltersStateInitialValue(CalculatorValueType.CONTRIBUTION, initialValues));
    const [period, setPeriod] = useState<number>(() => setFiltersStateInitialValue(CalculatorValueType.PERIOD, initialValues));
    const [areDefaultValuesSet, setAreDefaultValuesSet] = useState<boolean>(false);

    useEffect(() => {
        const filtersStorage = getCreditFiltersStorage();

        if (!isEmpty(filtersStorage)) {
            updateAllValues(filtersStorage.price, filtersStorage.contribution, filtersStorage.period);
        }

        setAreDefaultValuesSet(true);
    }, []);

    const updateValue = (type: CalculatorValueType, value: number) => {
        switch (type) {
            case CalculatorValueType.PRICE:
                setPrice(value);
                break;
            case CalculatorValueType.CONTRIBUTION:
                setContribution(value);
                break;
            case CalculatorValueType.PERIOD:
                setPeriod(value);
                break;
            default:
                console.error("modifyValue - type error");
        }
    };
    const updateAllValues = (price: number, contribution: number, period: number) => {
        setPrice(price);
        setContribution(contribution);
        setPeriod(period);
    };

    return {price, contribution, period, areDefaultValuesSet, updateValue};
};
